import React from 'react';
import ErrorBoundary from './ErrorBoundary';

const PageErrorBoundary = ({ children, pageName }) => {
  return (
    <ErrorBoundary 
      fallbackMessage={`An error occurred while loading the ${pageName} page. Please try refreshing the page.`}
      showRetry={true}
    >
      {children}
    </ErrorBoundary>
  );
};

export default PageErrorBoundary;



